module.exports = __webpack_public_path__ + "static/media/shaff1139.ff7cb8a4.jpg";